import React from "react";
import { useState, useImperativeHandle, forwardRef } from "react";
import { _batchBattery, _getBatteryStatus } from "@/statics/js/api.js";
import { Form, Modal, Select, Row, Col, message, Table,Button,Input } from "antd";
import BatteryModelSelect from '@/components/batteryModelSelect'
const { Option } = Select;
const statusOptions = [
    {value: 0,label: '禁用'},
    {value: 1,label: '正常'},
    {value: 2,label: '待确认'},
    {value: 3,label: '已出售'},
    {value: 4,label: '维修中'},
]
var Index = forwardRef((props, ref) => {
  const columns = [
    {
      title: "电池编号",
      dataIndex: "imei",
      width: 200,
    },
    {
      title: "状态",
      dataIndex: "status",
      render: (text) => {
        const {label=''} = statusOptions.find(item=>item.value == text)
        return label
      },
    },
    {
      title: "电池型号",
      dataIndex: "modelName",
    },
    {
        title: "是否需要维修",
        dataIndex: "needRepair",
        render: (text) => text ? '需要' : '不需要',
      },
      {
        title: "代理商",
        dataIndex: "fname",
      },
      {
        title: "站点",
        dataIndex: "sname",
      },
      {
        title: "操作",
        dataIndex: "",
        width: 140,
        key: "Action",
        render: (text, record, index) => {
            return (
              <Button type="link" onClick={()=>handleRmove(record)}>
                移除
              </Button>
            );
          },
      },
  ];
  const { form, done } = props;
  const { getFieldDecorator,getFieldValue } = form;
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [list, setList] = useState([]);
  useImperativeHandle(
    ref,
    () => ({
      open,
    }),
    []
  );
  const open = async ({ selectedRowKeys }) => {
    setVisible(true);
    form.resetFields();
    setList([])
    getList({selectedRowKeys})
  };
  const close = async () => {
    setVisible(false);
  };
  const handleRmove = (record)=>{
    if(list.length <= 1){
        message.warning("至少保留一条数据");
        return
    }
    const arr = list.filter(item=>item.id != record.id)
    setList(arr)
  }
//   获取列表
  const getList = async ({selectedRowKeys})=>{
    let params = { ids: selectedRowKeys };
    setLoading(true)
    const res = await _getBatteryStatus(params);
    setLoading(false)
    setList(res.data.data || [])
  }
  // 提交
  const handleOk = () => {
    form.validateFields(async (err, values) => {
        if (err) return;
        const params = { 
            ...values,
            ids: list.map(item=>item.id)
        };
        setConfirmLoading(true);
        const res = await _batchBattery(params);
        setConfirmLoading(false);
        const { code, message: msg } = res.data || {};
        if (code != 200) {
            message.warning(msg);
            return;
        }
        message.success("操作成功");
        done();
        close();
    });
  };
  return (
    <div>
      <Modal
        title="批量编辑"
        visible={visible}
        width={1100}
        onOk={handleOk}
        onCancel={close}
        confirmLoading={confirmLoading}
      >
        <Form>
          <Row>
              <Col span={24}>
                <Form.Item label="状态">
                  {getFieldDecorator("status")(
                    <Select
                    style={{ width: "100%" }}
                    placeholder="请选择"
                    allowClear
                    >
                        {
                            statusOptions.map(item=>(<Option value={item.value} key={item.value}>{item.label}</Option>))
                        }
                    </Select>
                  )}
                </Form.Item>
              </Col>
            <Col span={24}>
              <Form.Item label="电池型号">
                {getFieldDecorator("modelId")(
                    <BatteryModelSelect />
                )}
              </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label="是否需要维修">
                {getFieldDecorator("needRepair")(
                    <Select
                    style={{ width: "100%" }}
                    placeholder="请选择"
                    allowClear
                    >
                    <Option value={1}>需要</Option>
                    <Option value={0}>不需要</Option>
                    </Select>
                )}
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label="备注">
                {getFieldDecorator("remark")(
                    <Input.TextArea
                        rows={2}
                        allowClear
                        placeholder="请输入"
                    />
                )}
                </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table
          loading={loading}
          rowKey="id"
          bordered
          columns={columns}
          scroll={{ x: 1000, y: 500 }}
          dataSource={list}
        />
      </Modal>
    </div>
  );
});

Index = Form.create({})(Index);
export default Index;
